<template>
    <div class="VueTables__search-field multiselect w-100">
        <div class="input-group">
            <input 
                class="form-control VueTables__search__input multiselect__tags mySelect w-100"
                type="text"
                placeholder="Որոնում"
                v-model="searchQuery"
                @keyup="handleSearchInput"
                @keyup.enter="handleEnterSearch"
                :id="`VueTables__search_${props.id}`"
                autocomplete="off"
            />
            <div class="input-group-append">
                <button @click="handleSearch" class="btn btn-primary" type="button">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</template>
<style scoped>
.VueTables__search__input{
    border: 1px solid #1e7bb7;
    color: #1e7bb7;
}
.mySelect::placeholder {
    color: #1e7bb7;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
}
.multiselect__tags{
    padding-top: 0;
}
</style>
<script>
    export default {
        name: "VtGenericFilter",
        props: ['props'],
        data() {
            return {
                searchQuery: '',
                searchInputEvent: {}
            }
        },
        methods: {
            handleSearchInput(e){
                this.searchInputEvent = e;
                if(!e.target.value){
                    this.handleSearch()
                }
            },
            handleEnterSearch() {
                this.props.search(this.props.debounce)(this.searchInputEvent)
            },
            handleSearch(){
                this.props.search(this.props.debounce)(this.searchInputEvent)
            }
        }
    }
</script>